
export const proto = {
  awsRegion: 'us-east-1',
  googleAnalyticsId: 'UA-47128313-3',
  googleAnalyticsSampleRate: 100,
  googleAnalyticsSpeedSampleRate: 100,
  cognitoIdentityPoolId: 'us-east-1:b2ad414c-6ed9-41f6-a644-29d664b20917',
  apiGatewayEndpoint: 'https://csp-api-dev.courtyardstone.com/dev',
  googleSignInParams: {
    client_id: '138058417459-dmrnk76c307n3hek4vodurvkognquvan.apps.googleusercontent.com'
  },
  facebookSignInParams: {
    init: {
      appId: '1587134934639684',
      cookie: true,
      xfbml: false,
      version: 'v2.9'
    },
    login: {
      scope: 'public_profile,email'
    }
  },
  amazonSignInParams: {
    clientId: 'amzn1.application-oa2-client.8f382628b91c471b89fa0f845021d5e3',
    scope: 'profile'
  },
  signinTimeout: 5000,
  website: 'https://www-dev.courtyardstone.com'
}

export default proto



// WEBPACK FOOTER //
// ./src/store/config/proto.js